var map = {
	"./aaa-it.jpeg": 99715,
	"./aaa-mtsbanraw.png": 42496,
	"./aaaa.png": 85253,
	"./aaaaa.png": 9096,
	"./aaaaaa.png": 54451,
	"./aaaaaaa.png": 19394,
	"./aaaaaaaa-mts.png": 3376,
	"./aaaaaaaaa-aeromodelling.jpeg": 31574,
	"./aaaaaaaaa-chem.jpeg": 46177,
	"./aaaaaaaaa-chemical.png": 79763,
	"./aaaaaaaaa-cit.jpeg": 62152,
	"./aaaaaaaaaa-chemical.png": 97054,
	"./ab-cse.png": 71920,
	"./ac-cse.png": 39261,
	"./ad-it.png": 77350,
	"./ae-eie.png": 51891,
	"./af-mechatronics.png": 22311,
	"./alumni-neha.jpeg": 75769,
	"./civil&ai.jpeg": 46967,
	"./genai.jpeg": 346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44138;